import './VideoThumbnail.scss';

import Badge from 'components/Badge/Badge';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as PlayButtonIcon } from 'images/icons/PlayButton.svg';
import { VideoUrlModel } from 'types/trackmanParameters';
import { observer } from 'mobx-react-lite';

type Props = {
  video: VideoUrlModel | string;
  setVisibleVideo?: (video: VideoUrlModel) => void;
  thumbnailSize?: string;
  badgeText?: string;
  badgeIcon?: React.ReactNode;
};

export const VideoThumbnail = observer(({ video, setVisibleVideo, thumbnailSize = 'mqdefault', badgeText, badgeIcon }: Props) => {
  const isVideoUrlModel = (video: VideoUrlModel | string): video is VideoUrlModel => {
    return (video as VideoUrlModel).videoUrl !== undefined;
  };

  return (
    <div className='video-item'>
      <div className='thumbnail-wrapper' onClick={() => isVideoUrlModel(video) && setVisibleVideo && setVisibleVideo(video)}>
        <img
          src={`https://img.youtube.com/vi/${isVideoUrlModel(video) ? video.videoUrl : video}/${thumbnailSize}.jpg`}
          alt={isVideoUrlModel(video) && video.label ? video.label : 'Video thumbnail'}
        />
        <span className='play-icon'>
          <PlayButtonIcon />
        </span>
        {badgeText && <Badge badgeText={badgeText} badgeIcon={badgeIcon} />}
      </div>
      {isVideoUrlModel(video) && video.label ? (
        <Paragraph>
          <>{video.label}</>
        </Paragraph>
      ) : null}
    </div>
  );
});

export default VideoThumbnail;
